import { apiClient } from "@/lib/api/axios";
import type {
  InvoiceCardCheckout,
  InvoicePaymentStatus,
  InvoicePixCharge,
  ListMyPaymentsParams,
  MyEntitlement,
  MySubscription,
  PagedPayments,
} from "../mocks/fixtures";

export async function getMySubscription(): Promise<MySubscription> {
  const { data } = await apiClient.get<MySubscription>("/me/subscription");
  return data;
}

/** Entitlement resolvido (status/cobertura/motivo) — isento do gate, usado pelo modal de plano. hub#489. */
export async function getMyEntitlement(): Promise<MyEntitlement> {
  const { data } = await apiClient.get<MyEntitlement>("/me/entitlement");
  return data;
}

export async function listMyPayments(params?: ListMyPaymentsParams): Promise<PagedPayments> {
  const { data } = await apiClient.get<PagedPayments>("/me/subscription/payments", { params });
  return data;
}

/** Cancela a assinatura end-of-period (ADR-0035): para de renovar, acesso até o vencimento. */
export async function cancelMySubscription(reason?: string): Promise<void> {
  await apiClient.post("/me/subscription/cancel", { reason });
}

/**
 * Troca a forma de pagamento / o cartão da recorrência (hub#405): devolve a URL do checkout
 * hospedado pra redirecionar. `returnUrl` = a própria tela de assinatura (volta e atualiza).
 */
export async function changePaymentMethod(returnUrl?: string): Promise<InvoiceCardCheckout> {
  const { data } = await apiClient.post<InvoiceCardCheckout>(
    "/me/subscription/payment-method/checkout",
    { returnUrl },
  );
  return data;
}

/**
 * Reprocessa uma fatura vencida/aberta via cartão (hub#405): devolve a URL do checkout hospedado
 * pra redirecionar. `returnUrl` = pra onde voltar após pagar (a própria tela de assinatura).
 */
export async function payInvoiceWithCard(
  invoiceId: string,
  returnUrl?: string,
): Promise<InvoiceCardCheckout> {
  const { data } = await apiClient.post<InvoiceCardCheckout>(
    `/me/subscription/invoices/${invoiceId}/pay/card`,
    { returnUrl },
  );
  return data;
}

/** Reprocessa uma fatura via PIX direto (copia-e-cola). CPF vem do perfil no backend. hub#405. */
export async function payInvoiceWithPix(invoiceId: string): Promise<InvoicePixCharge> {
  const { data } = await apiClient.post<InvoicePixCharge>(
    `/me/subscription/invoices/${invoiceId}/pay/pix`,
    {},
  );
  return data;
}

/** Status do pagamento (a tela consulta enquanto aguarda o webhook confirmar). hub#405. */
export async function getInvoicePaymentStatus(
  gatewayChargeId: string,
): Promise<InvoicePaymentStatus> {
  const { data } = await apiClient.get<InvoicePaymentStatus>(
    `/me/subscription/payments/${encodeURIComponent(gatewayChargeId)}/status`,
  );
  return data;
}
